'use client'

import { useEffect, useState } from 'react'
import Head from 'next/head'

export default function DynamicHead() {
  const [title, setTitle] = useState('Default Title')
  const [description, setDescription] = useState('Default description for the page.')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname
      const suffixMatch = hostname.match(/orthoped(?:ic|ics|ist)/i)
      const suffix = suffixMatch ? suffixMatch[0] : 'Orthopedic'
      const city = hostname
        .split(/orthoped(?:ic|ics|ist)/i)[0]
        .replace(/[.-]/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim()

      if (city) {
        setTitle(`${city} ${suffix} Domain Lease`)
        setDescription(`Secure the premium domain ${city}${suffix}.com for your practice. Dominate local SEO and attract more patients in ${city}.`)
      }
    }
  }, [])

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
    </Head>
  )
} 